<section class="terminate-lease-agreement">
  <div class="header">
    <h1>{{ 'TERMINATE_LEASE_AGREEMENT_FORM.HEADER' | translate }}</h1>
  </div>
  <div class="form-group">{{ 'LEASE_AGREEMENT.LEASE_AGREEMENT_NUMBER' | translate }}: {{ leaseAgreementNumber }}</div>

  <div class="form-group">
    <div class="row">
      <div class="col-12 col-md-6">
        <app-date-picker
          [form]="form.controls['terminationDate']"
          [isRequired]="true"
          [title]="'TERMINATE_LEASE_AGREEMENT_FORM.TERMINATED_DATE_LABEL'"
          [model]="terminationDate"
          [helpText]="'TERMINATE_LEASE_AGREEMENT_FORM.HELP_TEXT.TERMINATED_DATE'"
        ></app-date-picker>
      </div>

      <div class="col-12 col-md-6">
        <app-select
          [control]="form.controls['terminatedBy']"
          [itemsSource]="terminatedByItems"
          [helpText]="'TERMINATE_LEASE_AGREEMENT_FORM.HELP_TEXT.TERMINATED_BY'"
        ></app-select>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-6">
        <app-date-picker
          [form]="form.controls['lastDebitDate']"
          [isRequired]="true"
          [title]="'TERMINATE_LEASE_AGREEMENT_FORM.LAST_DEBIT_DATE_LABEL'"
          [model]="lastDebitDate"
          [helpText]="'TERMINATE_LEASE_AGREEMENT_FORM.HELP_TEXT.LAST_DEBIT_DATE'"
        ></app-date-picker>
      </div>

      <div class="col-12 col-md-6">
        <app-date-picker
          [form]="form.controls['desiredRemovalDate']"
          [isRequired]="true"
          [title]="'TERMINATE_LEASE_AGREEMENT_FORM.DESIRED_REMOVAL_LABEL'"
          [model]="desiredRemovalDate"
          [helpText]="'TERMINATE_LEASE_AGREEMENT_FORM.HELP_TEXT.DESIRED_REMOVAL'"
        ></app-date-picker>
      </div>
    </div>
  </div>

  @if (displayDigitalSigningSection) {
    <section class="astral-section-surface astral-stack-m">
      <astral-toggle [control]="form.controls['useDigitalSigning']"></astral-toggle>

      @if (displayDigitalSigning) {
        <app-information-block
          [text]="(terminatedByLandlord && !form.controls['requireSignatureBeforeTermination'].value
            ? 'TERMINATE_LEASE_AGREEMENT_FORM.ESIGNATURE_IMMEDIATE_COMPLETION'
            : 'TERMINATE_LEASE_AGREEMENT_FORM.ESIGNATURE_DEFERRED_COMPLETION') | translate"
        ></app-information-block>
        @if (terminatedByLandlord) {
          <astral-layout-group [columns]="2" [tabletColumns]="1" [mobileColumns]="1">
            <astral-toggle [control]="form.controls['requireSignatureBeforeTermination']"></astral-toggle>
            <astral-textarea [control]="form.controls['landlordMessage']" [rows]="4"></astral-textarea>
          </astral-layout-group>
        }
        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
          <astral-date-picker [control]="form.controls['expirationDate']" [label]="'ESIGNATURE.EXPIRATION_DATE'"></astral-date-picker>
          <astral-input class="astral-grid-desktop-span-3" [control]="form.controls['errandDescription']"></astral-input>
          <astral-toggle [control]="form.controls['informWhenSigned']"></astral-toggle>
          @if (form.controls['informWhenSigned'].value) {
            <astral-input
              class="astral-grid-desktop-span-3"
              [control]="form.controls['informEmailAddress']"
              [type]="'email'"
            ></astral-input>
          }
        </astral-layout-group>
        <section class="astral-section-surface astral-section-surface--nested astral-stack-m">
          <h4>{{ 'ESIGNATURE.SIGNATORIES' | translate }}</h4>
          <div class="astral-stack-m">
            @for (sform of signatoryForms; track sform; let i = $index) {
              <section class="astral-section-surface astral-section-surface--compact astral-section-surface--subtle astral-stack-m">
                <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
                  <astral-input [control]="sform.controls['name']"></astral-input>
                  <astral-input [control]="sform.controls['email']" [type]="'email'"></astral-input>
                  <astral-input [control]="sform.controls['phone']" [type]="'phone'"></astral-input>
                  <astral-select [control]="sform.controls['informationChannel']" [itemsSource]="informationChannels"></astral-select>
                  <astral-select [control]="sform.controls['signingRole']" [itemsSource]="signingRoles"></astral-select>
                  <astral-select [control]="sform.controls['signatureType']" [itemsSource]="signatureTypeSelection"></astral-select>
                  <astral-input [control]="sform.controls['civicNumber']"></astral-input>
                  <astral-input [control]="sform.controls['signOrder']" [type]="'number'"></astral-input>
                  <astral-select [control]="sform.controls['signatureReminderSetting']" [itemsSource]="signatureReminderSettingSelection"></astral-select>
                  @if (i > 0) {
                    <div class="astral-form-adjacent-action">
                      <astral-button variant="secondary" size="small" type="button" labelKey="DELETE_BTN" icon="trash" (click)="deleteSignatory(i)"></astral-button>
                    </div>
                  }
                </astral-layout-group>
              </section>
            }
          </div>
          <div class="astral-form-actions astral-form-actions--start">
            <astral-button variant="primary" size="small" type="button" labelKey="ESIGNATURE.ADD_SIGNATORY" icon="plus" (click)="newSignatory()"></astral-button>
            <astral-button variant="secondary" size="small" type="button" labelKey="PREVIEW_BTN" (click)="previewDigitalSigningDocument()"></astral-button>
          </div>
        </section>
      }
    </section>
  }

  <div class="form-group">
    @if (displayCreditInvoices) {
      <div class="row">
        <div class="col-12">
          @if (!hasJointDebitInvoice) {
            <app-information-block
              [text]="'LEASE_AGREEMENT.INFORMATION_TEXT.CREDIT_INVOICES' | translate"
            ></app-information-block>
          }
          @if (hasJointDebitInvoice) {
            <app-information-block
              [text]="'LEASE_AGREEMENT.INFORMATION_TEXT.CREDIT_INVOICES_JOINT_DEBIT' | translate"
            ></app-information-block>
          }
          <app-multiselect-list-view
            [itemsSource]="invoices"
            [columnDefinition]="invoicesColumnDefinitions"
            [selectAll]="true"
            [preferencesKey]="'rent.terminate-lease-agreement.invoices'"
            >
          </app-multiselect-list-view>
        </div>
      </div>
    }
  </div>

  <div class="form-group">
    @if (useDwellingInspection) {
      <div>
        @if (!dwellingInspectionTypeMainName && !dwellingInspectionTypeOptionalName) {
          <app-information-block
            [text]="'TERMINATE_LEASE_AGREEMENT_FORM.DWELLING_GENERATION_INFO' | translate"
          ></app-information-block>
        }
        @if (dwellingInspectionTypeMainName) {
          <app-information-block
        [text]="
          (dwellingInspectionTypeOptionalName
            ? ('TERMINATE_LEASE_AGREEMENT_FORM.DWELLING_GENERATION_INFO_TWO_TYPES'
              | translate: { typeOne: dwellingInspectionTypeMainName, typeTwo: dwellingInspectionTypeOptionalName })
            : ('TERMINATE_LEASE_AGREEMENT_FORM.DWELLING_GENERATION_INFO_ONE_TYPE'
              | translate: { typeOne: dwellingInspectionTypeMainName })) +
          '\n' +
          ('TERMINATE_LEASE_AGREEMENT_FORM.DWELLING_GENERATION_INFO' | translate)
        "
            >
          </app-information-block>
        }
      </div>
    }
  </div>
  <div class="terminate-lease-agreement__actions">
    <astral-button variant="primary" type="button" labelKey="SAVE_BTN" (click)="save()"></astral-button>
    <astral-button variant="secondary" type="button" labelKey="CANCEL_BTN" (click)="cancel()"></astral-button>
  </div>
</section>
